"use strict";

angular.module("core")
.component("dateFilter", {
    bindings: {
        filterTitle: "<",
        filterField: "@",
    },
    templateUrl: require("./date-filter.component.html"),
    controllerAs: "dateFilterCtrl",
    controller: function() {}
});



//////////////////
// WEBPACK FOOTER
// ./core/date-filter/date-filter.component.js
// module id = 593
// module chunks = 0